import React from 'react';
import { Box, Container, Heading, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);
const MotionHeading = motion(Heading);
const MotionText = motion(Text);

const ContactHero = ({ data }) => {
  return (
    <Box bg="brand.700" color="white" py={{ base: 16, md: 24 }}>
      <Container maxW="container.xl">
        <MotionBox
          textAlign="center"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <MotionHeading
            as="h1"
            fontSize={{ base: '3xl', md: '5xl', lg: '6xl' }}
            fontFamily="heading"
            mb={4}
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            {data.title}
          </MotionHeading>
          
          <MotionText
            fontSize={{ base: 'lg', md: 'xl' }}
            maxW="2xl"
            mx="auto"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            {data.subtitle}
          </MotionText>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default ContactHero;
